module.exports = __webpack_public_path__ + "img/videoPoster6.8c58d272.jpg";